import { useHttpClient } from './httpClient.js';

const resource = 'users';

export function createUser(user) {
	return useHttpClient().post(`/${resource}`, { user });
}

export function fetchUsers() {
	return useHttpClient().get(`/${resource}`);
}

export function fetchUser(id) {
	return useHttpClient().get(`/${resource}/${id}`);
}

export function updateUser(id, user) {
	return useHttpClient().put(`/${resource}/${id}`, { user });
}
